import request from '../utils/request'

export default class MonitorApi {

    /**
     * 一健已度
     * @param params
     * @returns {*|Promise<*>}
     */
    static batchRead = (params) => {
        return request.post('/sw-sewage/api/0/thirdMsg/batchRead', params)
    }

     /**
     * 获取列表
     * @param params
     * @returns {*|Promise<*>}
     */
    static listByPage = (params) => {
        return request.post('/sw-tenant/api/tenant/log/pageList', params)
    }

     /**
     * 读取
     * @param params
     * @returns {*|Promise<*>}
     */
    static read = (params) => {
        return request.post('/sw-sewage/api/0/thirdMsg/read', params)
    }

     /**
     * 读取
     * @param params
     * @returns {*|Promise<*>}
     */
    static listByTypeName = (params) => {
        return request.post('/sw-sewage/api/0/thirdMsg/listByTypeName', params)
    }
  
    static userOptionList = (params) => {
        return request.post(`/ocp-saas/api/0/user/optionList`, params)
    }
}
